var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "white-list" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("异常记录")]),
      _c(
        "el-form",
        { staticClass: "search-form", attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { staticClass: "date" },
            [
              _c("el-date-picker", {
                staticClass: "date-picker",
                style: { width: "330px" },
                attrs: {
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  clearable: "",
                  "default-time": ["00:00:00", "23:59:59"],
                },
                on: {
                  blur: function ($event) {
                    _vm.isRestart = true
                  },
                },
                model: {
                  value: _vm.dateValue,
                  callback: function ($$v) {
                    _vm.dateValue = $$v
                  },
                  expression: "dateValue",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _vm._v("\n      异常类型\n      "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "130px" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.type,
                    callback: function ($$v) {
                      _vm.type = $$v
                    },
                    expression: "type",
                  },
                },
                _vm._l(_vm.logTypeData, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _vm._v("\n      状态\n      "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "110px" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.status,
                    callback: function ($$v) {
                      _vm.status = $$v
                    },
                    expression: "status",
                  },
                },
                _vm._l(_vm.statusList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "230px" }, attrs: { label: "设备标识" } },
            [
              _c("el-input", {
                staticStyle: { width: "160px" },
                attrs: { placeholder: "请输入设备标识", clearable: "" },
                model: {
                  value: _vm.deviceIdentification,
                  callback: function ($$v) {
                    _vm.deviceIdentification = $$v
                  },
                  expression: "deviceIdentification",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "search-btn" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-export",
                  attrs: {
                    type: "primary",
                    disabled: !_vm.multipleSelection.length,
                    size: "14",
                  },
                  on: { click: _vm.handleExport },
                },
                [_vm._v("导出")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-query",
                  attrs: { type: "primary", size: "14" },
                  on: {
                    click: function ($event) {
                      return _vm.queryList("search")
                    },
                  },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "num-title" }, [
        _vm._v(
          "总数量：" +
            _vm._s(_vm.infoData.totalAmount) +
            "，未处理数量：" +
            _vm._s(_vm.infoData.pendingAmount)
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            size: "medium",
            "header-cell-style": { background: "#F5F6F7" },
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.createTime || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "异常类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.type === 0 ? "三元组" : "白名单") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "设备标识" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type === 1
                      ? _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(scope.row.deviceIdentification || "-") +
                              "\n        "
                          ),
                        ])
                      : _c("div", [
                          _c("div", [
                            _vm._v(_vm._s(scope.row.deviceName || "-")),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(scope.row.deviceSecret || "-")),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(scope.row.productKey || "-")),
                          ]),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0
                      ? _c("span", [_vm._v("未处理")])
                      : _c("span", [_vm._v("已处理")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "异常原因" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.exceptionReason || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "报错次数" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.exceptionCount) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "处理意见" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.handlingOpinion || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type === 0 && scope.row.status === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "operate" },
                            on: {
                              click: function ($event) {
                                return _vm.jumpDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                    !scope.row.status
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "operate" },
                            on: {
                              click: function ($event) {
                                return _vm.handleReason(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("处理")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 20, 50],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "处理意见",
            visible: _vm.dialogVisible,
            width: "596px",
            "before-close": _vm.handleClose,
            "custom-class": "white-list-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.addFormData,
                rules: _vm.rules,
                width: "596px",
                "label-width": "80px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "处理意见", prop: "handlingOpinion" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入处理意见，1~100字符",
                      type: "textarea",
                      maxlength: "100",
                      "show-word-limit": "",
                      rows: 6,
                      clearable: "",
                    },
                    model: {
                      value: _vm.addFormData.handlingOpinion,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "handlingOpinion", $$v)
                      },
                      expression: "addFormData.handlingOpinion",
                    },
                  }),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v("点击确认后，该异常记录状态已处理"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "14" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "14" },
                  on: { click: _vm.onsubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "异常三元组查询结果",
            visible: _vm.dialogViewVisible,
            "custom-class": "view-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogViewVisible = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", [
              _vm._v(
                "DeviceName：" +
                  _vm._s(
                    (_vm.gridData.length && _vm.gridData[0].deviceNameError) ||
                      "-"
                  )
              ),
            ]),
            _c("div", [
              _vm._v(
                "DeviceSecret：" +
                  _vm._s(
                    (_vm.gridData.length &&
                      _vm.gridData[0].deviceSecretError) ||
                      "-"
                  )
              ),
            ]),
            _c("div", [
              _vm._v(
                "ProductKey：" +
                  _vm._s(
                    (_vm.gridData.length && _vm.gridData[0].productKeyError) ||
                      "-"
                  )
              ),
            ]),
          ]),
          _c("div", { staticClass: "view-title" }, [
            _vm._v(
              "标记的为与当前设备不匹配项。若列表无结果，则表示未生成过相关联三元组"
            ),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.gridData } },
            [
              _c("el-table-column", {
                attrs: { label: "订单号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.orderNo || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "产品PID" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.productId || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "DeviceName" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.deviceNameCorrect || "-") +
                            "\n          "
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              "text-danger": !scope.row.deviceNameIsCorrect,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.deviceNameCorrect || "-") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "DeviceSecret" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "text-danger": !scope.row.deviceSecretIsCorrect,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.deviceSecretCorrect || "-") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "ProductKey" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.productKeyCorrect || "-") +
                            "\n          "
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              "text-danger": !scope.row.productKeyIsCorrect,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.productKeyCorrect || "-") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "14" },
                  on: {
                    click: function ($event) {
                      _vm.dialogViewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }